export default "__VITE_ASSET__C4$gPia2__"